import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { StoreContext } from '../../context/StoreContext';

import CollectionFilterLinklist from './collection-filter-linklist';

import ChevronRight from '../../images/icons/chevron-right.inline.svg';
import { TransitionMixin, media } from '../helpers';

const CollectionFilterContainer = styled.div`
    .filter-title {
    }

    .clear-btn {
        display: none;
    }

    .filter-linklist {
        margin-bottom: 10px;
        ${media.medium`display: block;margin-bottom: 50px;`}
        > ul {
            margin: 0;
            padding: 0;
            list-style: none;
            @media (max-width: 992px) {
                white-space: nowrap; /* [1] */
                overflow-x: auto; /* [2] */
                -webkit-overflow-scrolling: touch; /* [3] */
                -ms-overflow-style: -ms-autohiding-scrollbar; /* [4] */
                &::-webkit-scrollbar {
                    display: none;
                }
            }

            li {
                margin-bottom: 0px;
                display: inline-block;
                margin-right: 20px;
                ${media.medium`margin-bottom: 20px;display: block;margin-right: 0px;`}
                &:last-child {
                    margin-bottom: 0px;
                }

                a {
                    color: #000;
                    text-decoration: none;
                    font-weight: 700;

                    &:hover,
                    &.active {
                        color: #13a6ab;
                    }
                }
            }
        }
        .mobile-active-filters {
            padding: 30px 0 0;
            ${media.medium`display: none;`}
            .breadcrumb-active-filters {
                display: flex;

                ul {
                    flex: 3;
                }
            }
        }
    }
    .refine-filter-container {
        > .inner-wrap {
            h4 {
                font-size: 1.3rem;
                margin: 0px 0px 20px;
                color: #000;
            }
            .acc-container {
                .acc-item {
                    &:first-child {
                        .acc-header button {
                            border-top: 2px solid #000;
                        }
                    }
                    .acc-header {
                        button {
                            width: 100%;
                            text-align: left;
                            background-color: transparent;
                            border: none;
                            border-bottom: 2px solid #000;
                            padding: 10px 0;
                            display: flex;
                            align-items: center;

                            &.active {
                                span {
                                    svg {
                                        transform: rotate(90deg);
                                    }
                                }
                            }

                            &:active,
                            &:focus {
                                outline: 0;
                            }

                            span {
                                margin-left: 5px;
                                &.icon {
                                    flex: 1;
                                    top: 4px;
                                    position: relative;
                                    text-align: right;

                                    svg {
                                        ${TransitionMixin('.25s')};
                                    }
                                }
                            }
                        }
                    }
                    .acc-body {
                        .inner-wrap {
                            padding: 15px 10px;
                            ul {
                                padding: 0;
                                margin: 0;
                                list-style: none;
                                li {
                                    margin-right: 10px;
                                    margin-bottom: 10px;
                                    display: inline-block;
                                    input {
                                        margin-right: 7px;
                                        position: relative;
                                        top: 2px;
                                    }

                                    label {
                                        font-size: 0.8rem;
                                        text-transform: capitalize;
                                    }
                                    button {
                                        text-transform: capitalize;
                                        background-color: #fff;
                                        border: 1px solid #000;
                                        border-radius: 5px;

                                        &.active,
                                        &:hover {
                                            background-color: #000;
                                            color: #fff;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    &.mobile-filter-container {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        background-color: red;
    }
`;

const CollectionFilter = ({
    setFilteredProducts,
    filteredProducts,
    allProducts,
    activeFilters,
    setActiveFilters,
    mobile,
}) => {
    const { colorHandlize, reverseColorHandlize } = useContext(StoreContext);

    // pull options from collection products

    const [filterOptions, setFilterOptions] = useState([]);

    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    // pulled from what is possbile
    function getFilterOptions() {
        let allPatterns = [];
        let allStyles = [];
        let allRecycledOptions = [];
        let allKidsOptions = [];

        allProducts &&
            allProducts.map((product) => {
                product.tags.map((tag) => {
                    let editedTag = tag.toLowerCase();
                    if (editedTag.includes('pattern_')) {
                        allPatterns.push(editedTag);
                    } else if (editedTag.includes('style_')) {
                        allStyles.push(editedTag);
                    } else if (editedTag === 'recycled_options') {
                        allRecycledOptions.push(editedTag);
                    } else if (editedTag === 'kids_options') {
                        allKidsOptions.push(editedTag);
                    }
                });
            });

        allPatterns = allPatterns.sort().filter(onlyUnique);
        allStyles = allStyles.sort().filter(onlyUnique);
        allRecycledOptions = allRecycledOptions.filter(onlyUnique);
        allKidsOptions = allKidsOptions.filter(onlyUnique);

        allStyles = allStyles;

        // console.log(allKidsOptions, allPatterns, allStyles, allRecycledOptions)

        setFilterOptions([
            {
                title: 'Pattern',
                options: allPatterns,
            },
            {
                title: 'Style',
                options: allStyles,
            },
            {
                title: 'Recycled Options',
                options: allRecycledOptions,
            },
            {
                title: 'Kids Options',
                options: allKidsOptions,
            },
        ]);
    }

    useEffect(() => {
        getFilterOptions();
        // console.log(filterOptions);
    }, []);

    // Filter

    function filterProducts() {
        let patternResultsArray = [];
        let styleResultsArray = [];
        let kidsOptionsResultsArray = [];
        let recycledOptionsResultsArray = [];

        let filteredProductsArray = [];
        const { pattern, style, kids_options, recycled_options } =
            activeFilters || {};

        if (pattern != null) {
            // check patterns

            allProducts.map((product) => {
                pattern.map((singlePattern) => {
                    product.tags.map((tag) => {
                        // console.log(singlePattern.value, tag);
                        if (
                            colorHandlize(tag) ===
                            colorHandlize(singlePattern.value)
                        ) {
                            patternResultsArray.push(product);
                        }
                    });
                });
            });
        }

        if (style != null) {
            // check patterns
            // console.log('patterns filter');
            allProducts.map((product) => {
                style.map((singleStyle) => {
                    product.tags.map((tag) => {
                        // console.log(singlePattern.value, tag);
                        if (
                            colorHandlize(tag) ===
                            colorHandlize(singleStyle.value)
                        ) {
                            styleResultsArray.push(product);
                        }
                    });
                });
            });
        }

        if (kids_options != null) {
            // check patterns
            // console.log('patterns filter');
            allProducts.map((product) => {
                kids_options.map((singleOption) => {
                    product.tags.map((tag) => {
                        // console.log(singlePattern.value, tag);
                        if (
                            colorHandlize(tag) ===
                            colorHandlize(singleOption.value)
                        ) {
                            kidsOptionsResultsArray.push(product);
                        }
                    });
                });
            });
        }

        if (recycled_options != null) {
            // check patterns
            // console.log('patterns filter');
            allProducts.map((product) => {
                recycled_options.map((singleOption) => {
                    product.tags.map((tag) => {
                        // console.log(singlePattern.value, tag);
                        if (
                            colorHandlize(tag) ===
                            colorHandlize(singleOption.value)
                        ) {
                            recycledOptionsResultsArray.push(product);
                        }
                    });
                });
            });
        }

        // after all filters, join them in one array

        filteredProductsArray = [
            ...styleResultsArray,
            ...patternResultsArray,
            ...kidsOptionsResultsArray,
            ...recycledOptionsResultsArray,
        ];

        // remove duplicate results
        filteredProductsArray = Array.from(
            new Set(filteredProductsArray.map((a) => a.handle))
        ).map((handle) => {
            return filteredProductsArray.find((a) => a.handle === handle);
        });

        // console.log('kids products', kidsOptionsResultsArray);
        // console.log('filtered products', filteredProductsArray);
        // if all values are null, reset the filter
        if (
            (pattern === null || pattern.length === 0) &&
            (style === null || style.length === 0) &&
            (recycled_options === null || recycled_options.length === 0) &&
            (kids_options === null || kids_options.length === 0)
        ) {
            setFilteredProducts(allProducts);
        } else {
            setFilteredProducts(filteredProductsArray);
        }

        // console.log('style results', styleResultsArray);
        // console.log('pattern results', patternResultsArray);
    }

    useEffect(() => {
        filterProducts();
    }, [activeFilters]);

    return (
        <CollectionFilterContainer className={mobile ? 'mobile-filter' : ''}>
            <CollectionFilterLinklist
                setActiveFilters={setActiveFilters}
                activeFilters={activeFilters}
            />
            <div className="refine-filter-container">
                <div className="inner-wrap">
                    <h4>Refine:</h4>
                    <div className="clear-btn">
                        <button
                            onClick={() =>
                                setActiveFilters({
                                    pattern: [],
                                    recycled_options: [],
                                    kids_options: [],
                                    style: [],
                                })
                            }
                        >
                            Clear all
                        </button>
                    </div>

                    <div className="acc-container">
                        {filterOptions.map((filterOption, index) => {
                            return (
                                <AccItem
                                    key={index}
                                    title={filterOption.title}
                                    options={filterOption.options}
                                    setActiveFilters={setActiveFilters}
                                    activeFilters={activeFilters}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        </CollectionFilterContainer>
    );
};

const AccItem = ({ title, options, setActiveFilters, activeFilters }) => {
    const [filterOpen, setFilterOpen] = useState(false);
    const [filtersActive, setFiltersActive] = useState([]);

    const { colorHandlize, reverseColorHandlize } = useContext(StoreContext);

    function handleButtonClick(e, value, filterName) {
        if (e.target.classList.contains('active')) {
            // remove button active color
            e.target.classList.remove('active');

            filterName = filterName
                .replace('recycled-options', 'recycled_options')
                .replace('kids-options', 'kids_options');

            // make a new array without the removed tag
            let updatedArray = activeFilters[colorHandlize(filterName)].filter(
                (array) => array.value !== value
            );

            // setFiltersActive(updatedArray);
            setActiveFilters({
                ...activeFilters,
                [filterName]: updatedArray,
            });
        } else {
            filterName = filterName
                .replace('recycled-options', 'recycled_options')
                .replace('kids-options', 'kids_options');

            let newFilter = {
                name: filterName,
                value,
            };

            let updatedArray = [
                ...activeFilters[colorHandlize(filterName)],
                newFilter,
            ];

            setFiltersActive(updatedArray);
            setActiveFilters({
                ...activeFilters,
                [filterName]: updatedArray,
            });

            e.target.classList.add('active');
        }
    }

    return (
        <AnimatePresence>
            {options.length > 0 && (
                <div className="acc-item">
                    <div className="acc-header">
                        <button
                            className={filterOpen ? 'active' : ''}
                            onClick={() => setFilterOpen(!filterOpen)}
                        >
                            Filter by {title}{' '}
                            {activeFilters[colorHandlize(title)] &&
                                activeFilters[colorHandlize(title)].length >
                                    0 && (
                                    <span>
                                        (
                                        {
                                            activeFilters[colorHandlize(title)]
                                                .length
                                        }
                                        )
                                    </span>
                                )}
                            <span className="icon">
                                <ChevronRight />
                            </span>
                        </button>
                    </div>
                    {filterOpen && (
                        <motion.div
                            className="acc-body"
                            key="content"
                            initial="collapsed"
                            animate="open"
                            exit="collapsed"
                            variants={{
                                open: { opacity: 1, height: 'auto' },
                                collapsed: { opacity: 0, height: 0 },
                            }}
                            transition={{
                                duration: 0.8,
                                ease: [0.04, 0.62, 0.23, 0.98],
                            }}
                        >
                            <div className="inner-wrap">
                                <ul>
                                    {options &&
                                        options.sort().map((option, index) => {
                                            let editedOption = option
                                                .toLowerCase()
                                                .replace('style_', '')
                                                .replace('pattern_', '')
                                                .replace(
                                                    'kids_options',
                                                    'Kids Options'
                                                );

                                            let specifiedFilter =
                                                activeFilters[
                                                    colorHandlize(
                                                        title
                                                            .replace(
                                                                'Kids Options',
                                                                'kids_options'
                                                            )
                                                            .replace(
                                                                'Recycled Options',
                                                                'recycled_options'
                                                            )
                                                    )
                                                ];
                                            let isFilterSelected =
                                                specifiedFilter &&
                                                specifiedFilter.filter(
                                                    (filter) =>
                                                        colorHandlize(
                                                            filter.value
                                                        ) ===
                                                        colorHandlize(option)
                                                ).length > 0;

                                            return (
                                                <li key={index}>
                                                    <button
                                                        className={
                                                            isFilterSelected
                                                                ? 'active'
                                                                : ''
                                                        }
                                                        name={colorHandlize(
                                                            title
                                                        )}
                                                        onClick={(e) =>
                                                            handleButtonClick(
                                                                e,
                                                                colorHandlize(
                                                                    option
                                                                ),
                                                                colorHandlize(
                                                                    title
                                                                )
                                                            )
                                                        }
                                                    >
                                                        {reverseColorHandlize(
                                                            editedOption
                                                        )}
                                                    </button>
                                                </li>
                                            );
                                        })}
                                </ul>
                            </div>
                        </motion.div>
                    )}
                </div>
            )}
        </AnimatePresence>
    );
};

export default CollectionFilter;
